import { Font } from '@pdf-lib/fontkit';
import { CharacterSwatchComponent } from './../character-swatch/character-swatch.component';
import { Component, HostBinding, Input, OnInit, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Output, ViewChildren, QueryList, HostListener } from '@angular/core';

@Component({
  selector: 'app-character-map',
  templateUrl: './character-map.component.html',
  styleUrls: ['./character-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CharacterMapComponent implements OnInit {

  @HostBinding('class.character-map') characterMapClass = true;

  private _font!: Font; // Fontkit font
  @Input()
  public set font(font: Font) {
    this._font = font;
    if(!this.data) return;
  }
  public get font(): Font {
    return this._font;
  }

  @Input() data: Array<any> = [];
  @Input() set fontName(name: string) {
    this.fontFamily = name;
  }
  @Input() from: number = -1;
  @Input() to: number = -1;
  fontSize = '16px';
  @Input() set size(inSize: string) {
    this.fontSize = inSize;
    this.cdr.detectChanges;
  }
  @Input() set color(inColor: string) {
    this.fontColor = inColor;
  }
  @HostBinding('style.font-family') fontFamily: string = '';
  @HostBinding('style.color') fontColor: string = '#000';
  public ready: boolean = false;
  private lastChar!: CharacterSwatchComponent;
  @Output() selection = new EventEmitter<CharacterSwatchComponent>();
  @ViewChildren(CharacterSwatchComponent) swatches = new QueryList<CharacterSwatchComponent>();
  @HostListener('window:keyup', ['$event']) KeyEvent(event: KeyboardEvent) {
    if ((event.target as HTMLElement).classList.contains('form-control')) {
      return;
    }
    if (!this.lastChar) {
      this.HandleCharSelection(this.swatches.first);
    }
    switch (event.key) {
      case 'ArrowUp':
        break;
      case 'ArrowLeft':
        this.selectedIndex -= 1;
        if (this.selectedIndex < 0) {
          this.selectedIndex = 0;
        }
        break;
      case 'ArrowRight':
        this.selectedIndex += 1;
        if (this.selectedIndex > this.swatches.length - 1) {
          this.selectedIndex = this.swatches.length - 1;
        }
        break;
      case 'ArrowDown':
        break;

    }
    this.HandleCharSelection(this.swatches.get(this.selectedIndex) as CharacterSwatchComponent);
  }
  private selectedIndex: number = -1;
  constructor(private domNode: ElementRef, private cdr: ChangeDetectorRef) {

  }
  ngOnInit(): void {

  }
  DrawMap() {
    this.ready = false;
    this.cdr.detectChanges();
    this.ready = true;
    this.cdr.detectChanges();
    this.SelectByCode(Number('0x'+this.data[0].name));

  }
  HandleCharSelection(character: CharacterSwatchComponent) {
    if (!character) return;
    if (this.lastChar) {
      this.lastChar.DeSelect();
    }

    this.lastChar = character;
    this.selectedIndex = this.swatches.toArray().indexOf(this.lastChar);
    this.selection.emit(this.lastChar);
    this.lastChar.Select();
    this.cdr.detectChanges();
  }
  SelectByCode(char: number) {
    let i = 0;
    for (const swatch of this.swatches.toArray()) {
      if (swatch.codePoint === char) {
        this.HandleCharSelection(swatch);
        return;
      }
      i++;
    }
  }
}
